import React from 'react'

import Button from '../../../../1stlog-ui/src/components/Button'
import { useField } from '../../../../1stlog-ui/src/components/Field'
import { useForm } from '../../../../1stlog-ui/src/components/Form'
import useRequireConfirmation from '../Form/Transport/RequireConfirmation/useRequireConfirmation'
import { useDeliveryProduct, usePickupProduct } from '../Products'
import useOrderEntry from '../useOrderEntry'

export type TProps = {
  isConfirmation?: boolean
}

const SubmitButton = (props: TProps): React.ReactElement => {
  const { isConfirmation } = props

  const form = useForm()

  const { preset } = useOrderEntry()

  const { skipConfirmation } = preset

  const isPickup = useField('isPickup')
  const isDelivery = useField('isDelivery')

  const pickup = useField('pickup')
  const delivery = useField('delivery')

  const pickupProduct = usePickupProduct()
  const deliveryProduct = useDeliveryProduct()

  const { isRequired } = useRequireConfirmation({
    pickup: true,
    delivery: true,
  })

  // const isRequestOnly = useMemo(() => {
  //   return (
  //     (isPickup && getIsRequestOnly(pickupProduct, pickup)) ||
  //     (isDelivery && getIsRequestOnly(deliveryProduct, delivery))
  //   )
  // }, [isPickup, isDelivery, pickup, delivery, pickupProduct, deliveryProduct])

  let buttonText

  if (isConfirmation || skipConfirmation) {
    if (isRequired) {
      buttonText = i18n.t('confirm_request', 'Anfrage bestätigen')
    } else {
      buttonText = i18n.t('order_submit_final', 'Final bestätigen')
    }
  } else {
    // if (isRequestOnly) {
    buttonText = i18n.t("order_submit_summary", "Weiter zur Zusammenfassung")
    // } else {
    //   buttonText = i18n.t("order_submit_summary", "Weiter zur Zusammenfassung")
    // }
  }

  return (
    <Button primary onClick={form.submit}>
      {buttonText}
    </Button>
  )
}

export default SubmitButton

// function getIsRequestOnly(product, settings) {
//   return lodash.some(['pickupTime', 'deliveryTime'], (time) => {
//     const option = lodash.find(
//       lodash.get(product, 'timeOptions'),
//       (o) => o.id === lodash.get(settings, [time, 'selectedTime'])
//     )
//     return lodash.get(option, 'isRequestOnly')
//   })
// }
